var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRestaurant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.897,
    height: 32.906,
    viewBox: "0 0 24.897 32.906",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-restaurant",
    "data-name": "Icon ionic-ios-restaurant",
    transform: "translate(-7.103 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "customStroke",
    id: "Trac\\xE9_235",
    "data-name": "Trac\\xE9 235",
    d: "M27,4.5c-1.744,0-3.375,6.423-3.375,13.294,0,4.736,2.25,6.647,2.25,6.647V35.077a1.141,1.141,0,1,0,2.25,0V5.414C28.125,4.5,27.352,4.5,27,4.5Z",
    transform: "translate(3.375)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "customStroke",
    id: "Trac\\xE9_236",
    "data-name": "Trac\\xE9 236",
    d: "M22.5,4.5l1.055,8.641a.868.868,0,0,1-1.687,0L21.234,4.5h-.844l-.633,8.641a.868.868,0,0,1-1.687,0L19.125,4.5h-.844S15.75,13.407,15.75,15.135a4.19,4.19,0,0,0,3.375,3.756V35.077a1.546,1.546,0,0,0,1.688,1.329A1.546,1.546,0,0,0,22.5,35.077V18.891a4.174,4.174,0,0,0,3.375-3.756c0-1.745-2.531-10.635-2.531-10.635Z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "customStroke",
    id: "Trac\\xE9_237",
    "data-name": "Trac\\xE9 237",
    d: "M11.386,4.5c-1.938,0-3.511,5.318-3.511,10.635a4,4,0,0,0,2.341,3.756V35.077a1.261,1.261,0,0,0,1.17,1.329,1.261,1.261,0,0,0,1.17-1.329V18.891A3.979,3.979,0,0,0,14.9,15.135C14.9,9.818,13.325,4.5,11.386,4.5Z",
    transform: "translate(-0.272)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRestaurant);
export default __webpack_public_path__ + "static/media/icon-restaurant.2f14194320d938c8411a7e19295fc3ff.svg";
export { ForwardRef as ReactComponent };